import { render, staticRenderFns } from "./showBanLiDialog.vue?vue&type=template&id=67484ed6&scoped=true&"
import script from "./showBanLiDialog.vue?vue&type=script&lang=js&"
export * from "./showBanLiDialog.vue?vue&type=script&lang=js&"
import style0 from "./showBanLiDialog.vue?vue&type=style&index=0&id=67484ed6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67484ed6",
  null
  
)

export default component.exports